/**
 * Forts' own names, per nation and fort class: real coastal fortresses of each country, one
 * word each. The n-th fort of a class (its id's number) takes the n-th name; a list is as long
 * as the largest game's count of the class (3 first-line and 3 second-line forts a side).
 * Names keep their own spelling in every language.
 */
type Names = Readonly<Record<string, readonly string[]>>;

const FORT_NAMES: Readonly<Record<string, Names>> = {
  spain: {
    first_line: ['Morro', 'Montjuïc', 'Galeras'],
    second_line: ['Atalaya', 'Bellver', 'Cabaña'],
  },
  france: {
    first_line: ['Boyard', 'Lamalgue', 'Taureau'],
    second_line: ['Liédot', 'Énet', 'Brescou'],
  },
  usa: {
    first_line: ['McHenry', 'Sumter', 'Moultrie'],
    second_line: ['Monroe', 'Pulaski', 'Adams'],
  },
  turkey: {
    first_line: ['Rumelihisarı', 'Kilitbahir', 'Seddülbahir'],
    second_line: ['Kumkale', 'Yedikule', 'Anadoluhisarı'],
  },
};

/** The name of a nation's `n`-th fort (from 1) of class `cls`, or null if it has none. */
export function fortName(nation: string, cls: string, n: number): string | null {
  return FORT_NAMES[nation]?.[cls]?.[n - 1] ?? null;
}

/** Every name a nation gives forts of class `cls`, in order. */
export function fortNames(nation: string, cls: string): readonly string[] {
  return FORT_NAMES[nation]?.[cls] ?? [];
}
